import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createSubCategory, CreateSubCategoryParams} from '../api';
import {QUERY__SUB_CATEGORIES} from '../queryKeys';

export const useCreateSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateSubCategoryParams) => createSubCategory(params),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__SUB_CATEGORIES, variables.categorySlug],
      });
    },
  });
};
